/** API client. */

import { hideLoader, showLoader, showToast } from "./utils";

export async function apiCall(
  url: string,
  method: string,
  body: any = null,
  isFormData = false,
  token: string | null = null
): Promise<any> {
  const options: RequestInit = { method, headers: {} };
  if (!isFormData && body) {
    (options.headers as Record<string, string>)["Content-Type"] = "application/json";
    options.body = JSON.stringify(body);
  }
  if (isFormData && body) options.body = body;
  const authToken = token || localStorage.getItem("token");
  if (authToken) {
    (options.headers as Record<string, string>)["Authorization"] = `Bearer ${authToken}`;
  }
  showLoader();
  try {
    const resp = await fetch(url, options);
    const data = await resp.json();
    if (!resp.ok) throw new Error(data.error || data.detail || `Ошибка ${resp.status}`);
    return data;
  } catch (err: any) {
    showToast(err.message, "error");
    return null;
  } finally {
    hideLoader();
  }
}

export const api = {
  get: (url: string) => apiCall(url, "GET"),
  post: (url: string, body: any) => apiCall(url, "POST", body),
  put: (url: string, body: any) => apiCall(url, "PUT", body),
  delete: (url: string) => apiCall(url, "DELETE"),
  upload: (url: string, formData: FormData) => apiCall(url, "POST", formData, true),
};
